import { render, staticRenderFns } from "./EmployeesSettings.vue?vue&type=template&id=003f2ae6&scoped=true&"
import script from "./EmployeesSettings.vue?vue&type=script&lang=js&"
export * from "./EmployeesSettings.vue?vue&type=script&lang=js&"
import style0 from "./EmployeesSettings.vue?vue&type=style&index=0&id=003f2ae6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "003f2ae6",
  null
  
)

export default component.exports